import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, mapProps } from 'recompose'

import {
  withViewProps,
  ModifyTable
} from 'components/custom/ModifyTable/index'

import styles from './styles.scss'

import {TableCell} from 'react-toolbox/lib/table'

// const view = {
//   name: {type: String, title: 'Partner Site'},
//   partner: { type: String, title: 'Partner'},
//   odm: { type: String, title: 'ODM'},
//   action: { title: ' ' }
// }

const tableHeadContent = {
    name: (<TableCell key={0}>Partner Site</TableCell>),
    partner: (<TableCell key={1}>Partner</TableCell>),
    odm: (<TableCell key={2}>ODM</TableCell>),
    action: (<TableCell key={3}>&nbsp;</TableCell>)
}
const withModelProps = mapProps(
  (props) => ({
    ...props,
    tableHeadContent
  })
)

const withStyle = CSSModules(styles)

export default compose(
  withModelProps,
  withViewProps,
  withStyle
)(ModifyTable)
